import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { useDocumentMeta } from "../lib/useDocumentMeta";

export const NotFoundPage = () => {
  useDocumentMeta({
    title: "Page not found · Will Not Be Forgotten",
    description: "The page you were looking for could not be found.",
  });
  return (
    <Layout headerVariant="solid">
      <section data-testid="not-found" className="section" style={{ paddingTop: "5rem", borderTop: "none" }}>
        <div className="shell">
          <span className="section__eyebrow">404</span>
          <h1 style={{ marginTop: 0 }}>This page could not be found.</h1>
          <p style={{ maxWidth: 540 }}>
            The link may be out of date, or the page may have moved. Return to the archive
            to keep exploring the dates we refuse to forget.
          </p>
          <Link to="/" className="btn btn--primary" style={{ marginTop: 18 }}>
            Return to the archive
          </Link>
        </div>
      </section>
    </Layout>
  );
};
